module.exports = __webpack_public_path__ + "static/media/icon_menu_business.bf220fd5.svg";